import './scss/main.scss'

const btOpen = document.querySelector('.header__button--open');
const btClose = document.querySelector('.header__button--close');
const menuMobile = document.querySelector('.menu-mobile');

if(btOpen) btOpen.addEventListener('click', toggleNav);
if(btClose) btClose.addEventListener('click', toggleNav);

function toggleNav(){
  if (menuMobile.classList.contains('opened')) {
    menuMobile.classList.remove('opened');
  } else {
    menuMobile.classList.add('opened');
  }
}
